import { AppDispatch } from '@/Redux/ConfigureStore';
import { useDispatch, useSelector } from 'react-redux';
import { emailSendModalActions, emailSendModalAsyncActions, SendEmailStep } from '../services/reducer';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';
import { salesPageSelectors } from '@/Pages/Sales/services';

export const useEmailSendModalActions = () => {
  const dispatch: AppDispatch = useDispatch();

  const emailTemplates = useSelector(emailSendModalSelectors.rows);
  const selectedSale = useSelector(salesPageSelectors.selectedSale);
  const documentType = useSelector(emailSendModalSelectors.documentType);

  const getEmailPreviewForOrder = (orderId: number, templateGuid: string) => {
    dispatch(
      emailSendModalAsyncActions.getEmailPreviewForOrder({
        orderId: orderId,
        templateGuid: templateGuid,
      }),
    );
  };

  const sendEmailForOrders = (orderIds: number[], templateGuid: string) => {
    dispatch(
      emailSendModalAsyncActions.sendEmailForOrders({
        templateGuid: templateGuid,
        orderIds: orderIds,
      }),
    );
  };

  const sendEmailForOrder = (orderId: number, templateGuid: string, numbers: string[]) => {
    dispatch(
      emailSendModalAsyncActions.sendEmailForOrder({
        templateGuid: templateGuid,
        orderId: orderId,
        numbers: numbers,
      }),
    );
  };

  const sendExistingDocuments = (selectedNumbers: string[]) => {
    if (!selectedSale) return;

    const emailTemplate = emailTemplates.find((item) => {
      return item.numberGenerationType == documentType;
    });

    if (!emailTemplate) {
      dispatch(emailSendModalActions.setSendEmailStep(SendEmailStep.TemplateNotExists));
      return;
    }

    const showPreview = emailTemplate.previewBeforeSending || !selectedSale?.buyerEmail;

    if (showPreview) {
      getEmailPreviewForOrder(selectedSale.id, emailTemplate.guid);
    } else {
      sendEmailForOrder(selectedSale.id, emailTemplate.guid, selectedNumbers);
    }
  };

  return {
    getEmailPreviewForOrder,
    sendEmailForOrders,
    sendExistingDocuments,
  };
};
